import { render, staticRenderFns } from "./StickyIdea.vue?vue&type=template&id=528f3729&"
import script from "./StickyIdea.vue?vue&type=script&lang=js&"
export * from "./StickyIdea.vue?vue&type=script&lang=js&"
import style0 from "./StickyIdea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports